import StockIdCell from "./StockIdCell"
import StockModelCell from "./StockModelCell"
import StockPriceCell from "./StockPriceCell"
import StockStatusCell from "./StockStatusCell"
import StockActionCell from "./StockActionCell"

export const getStockColumns = ({
  navigate,
  isMobile,
  toggleRow,
  isExpanded,
  handleStockClick,
  onClickDelete,
  onClickDownload,
  openImageViewer,
  setImageTitle,
  onPreviewDriveImages,
  onReadyStockToggle,
  readyStockUpdatingId,
}) => [
  {
    header: "Stock ID",
    cell: ({ row }) => (
      <StockIdCell
        stock={row.original}
        openImageViewer={openImageViewer}
        setImageTitle={setImageTitle}
      />
    ),
  },
  {
    header: "Model",
    cell: ({ row }) => (
      <StockModelCell
        stock={row.original}
        rowId={row.id}
        isMobile={isMobile}
        toggleRow={toggleRow}
        isExpanded={isExpanded}
        onPreviewDriveImages={onPreviewDriveImages}
      />
    ),
  },
  {
    header: "Price",
    cell: ({ row }) => <StockPriceCell stock={row.original} />,
  },
  {
    header: "Status",
    cell: ({ row }) => <StockStatusCell stock={row.original} />,
  },
  {
    header: "Action",
    cell: ({ row }) => (
      <StockActionCell
        stock={row.original}
        navigate={navigate}
        handleStockClick={handleStockClick}
        onClickDelete={onClickDelete}
        onClickDownload={onClickDownload}
        onReadyStockToggle={onReadyStockToggle}
        readyStockUpdatingId={readyStockUpdatingId}
      />
    ),
  },
]
